// Backend data (dummy data for now)
export const storiesData = [
  {
    id: 1,
    title: "The Townhall Clap",
    description: `The room was full of applause. The director was naming people who’d done well.

Nikhil stood up when he heard his name. He buttoned his jacket, walked up confidently, shook hands, and sat down — calm and composed, like someone used to being noticed.

Tanya, a few rows behind, clapped softly without looking up. She had stayed up late reviewing slides. The printout was still in her bag. When it ended, she quietly packed and left.

Up on the balcony, Jeevan leaned on the railing, eating a samosa and sipping Coke. His laptop showed a paused YouTube video. He didn’t clap. He smirked, sent a text, and only left once the muffins were gone.`,
  },
  {
    id: 2,
    title: "The Layoff Memo",
    description: `The subject line read: “Company Update: Strategic Realignment.”
Everyone knew what that meant. Layoffs.

The office was unusually quiet. Even people without headphones had them on — just to mute the silence.

Vikram arrived with coffee and a printed agenda. “Let’s stay focused,” he said, pinning it to the board. When someone asked if their team was safe, he replied, “Let’s not guess.”

Kabir sat nearby refreshing Slack, with LinkedIn, Naukri, and HR policies open. When asked if he was okay, he nodded but didn’t look up. He had lunch alone, scrolling on his phone.

Sana was writing a long message to her manager. Not about her job — but about how decisions were being made. She re-read it twice… and deleted the second half.`,
  },
  {
    id: 3,
    title: "The Cross-Team Conflict",
    description: `Design and product were fighting again.
The director called it “collaborative misalignment.” Everyone else called it a mess.

Slack had three long argument threads. Two meetings got delayed. A comment on the shared doc quietly vanished.

Priya was in both group chats. She replied “Totally get it 💯” in design, and “Makes sense — will align with the team” in product. She didn’t share her real opinion. Then she muted both threads.

Anuj hadn’t said much publicly. But he sent a screenshot to a director: “Might want to get ahead of this.” Later, he showed up at the design team’s desk with brownies: “Can we reset vibes before this explodes?”

Naveen, the actual project lead, said nothing. He created a Jira ticket: “Team Sync: Clarify Alignment.” He tagged everyone, marked it high priority, and went back to prepping next week’s deck.`,
  },
  {
    id: 4,
    title: "The Appraisal Puzzle",
    description: `It was appraisal season. The room had no signal, and just one window.

Rajat came in with a thick binder — color-coded tabs, printed metrics. When his manager suggested changing some goals, he quickly agreed. “Of course. Whatever you think’s best,” he said, already editing.

Meera came with a blank sheet. When asked about her goals, she gave short answers: “They’re fine.” “It’s okay.” She paused often, like trying to remember who she’d been six months ago. Before leaving, she asked, “Do I need to sign anything?” and added, “Thanks for the time.”

Fatima had her own notes: metrics, feedback quotes. When told, “You’re not always aligned,” she paused. “With the company or with you?” she asked. Then she said thanks, and left.`,
  },
  {
    id: 5,
    title: "The New Joiner Dilemma",
    description: `Arjun had joined two months ago. The welcome cake wasn’t even stale.

On Friday, his manager pinged: “Need a quick pitch deck by EOD.” Arjun said yes immediately. He scrambled to gather info from three teams, worked late, and added Dev and Chhavi’s names on the title slide — just to be nice.

Chhavi noticed. “We didn’t really help,” she whispered. Dev shrugged. “Just smile and wave — he’s trying too hard.”

By 9 p.m., Arjun was still at his desk, fixing fonts, checking transitions. He sent the final deck at 10:42 p.m.

No one replied.`,
  },
  {
    id: 6,
    title: "The Ethics Debate",
    description: `The client wanted the numbers changed — just slightly, to look better.

Everyone knew what that meant. No one said it.

Rhea stared at the Excel sheet. “This isn’t what we agreed on,” she said. Silence. “Should I do it, or will someone else?” Still silence. She hit save and left for coffee.

Sahil didn’t speak either. He left a comment: “Need clarity on this input source,” then muted the thread. That night, he quietly removed his name from the report.

Nitin straightened his shirt. “Let’s be practical,” he said. He reused an older report, adjusted a few numbers, and added a footnote: “Based on revised inputs.” Then he messaged, asking if someone else could make the slides.`,
  },
  {
    id: 7,
    title: "The Project Switch",
    description: `A week before the client call, things changed.

A Slack ping: “Varun will now present. Please align.”
Varun replied 👍. By 6 p.m., he’d renamed the deck, removed three slides, added his intro, and sent it to the director: “Just streamlined it a bit. Let me know.”

Lata didn’t complain. She updated the handover doc, added links, screenshots, even jokes. Then she quietly deleted the line: “original framework by Lata (April).”

At 9:14 p.m., she messaged: “Let me know if you need anything else :)” — she rewrote the smiley three times before hitting send.
Om, who’d built most of the backend, left one comment: “Check logic on slide 14.” He skipped the prep call and logged off by 7:23. The next morning, he filled out a transfer form.`,
  },
  {
    id: 8,
    title: "The Territory Line",
    description: `Niyati had led the project from day one — the brainstorm, the folder name, even the first draft. At lunch, she said, “This feels like my baby.” Everyone nodded.

Then the client changed the scope.

The manager messaged: “Let’s bring in Zubin for a fresh perspective.”

Zubin was polite. He left a few comments and added a new slide: “Possible alternate flow.”

Niyati replied fast: “Let’s stay focused. We already agreed on the structure.”

Sana had been quietly supporting — cleaning slides, replying to emails, saving backups.

When the conflict started, she didn’t take sides. She messaged both: “Want me to merge versions? Totally okay either way.” No reply.

At 10:36 p.m., she merged the decks, matched colors, removed names from the title. At 12:07 a.m., she uploaded it as “Final_v5_Sync.”
Next morning, the manager reacted with a 👍.`,
  },
];


// // Backend data (dummy data for now)
// export const storiesData = [
//   {
//     id: 1,
//     title: "The Townhall Clap",
//     description: `The room was filled with claps. The director was announcing names of people who had done well.

// Nikhil stood up when his name was called. He buttoned his jacket, walked up confidently, shook hands, and returned to his seat without showing much emotion. He looked polished and prepared — like someone used to being seen.

// Tanya, sitting a few rows back, clapped softly. Her eyes stayed down. She had stayed up reviewing slides last night. The printout was still in her bag. When the announcements ended, she quietly packed up, not waiting around.

// Watching from above, Jeevan leaned on the railing, eating a samosa and sipping Coke. His laptop was open to a paused YouTube video. He didn’t clap, didn’t seem bothered. He smirked, sent a text, and only left when the muffins were gone.`,
//   },
//   {
//     id: 2,
//     title: "The Layoff Memo",
//     description: `The email said: “Company Update: Strategic Realignment.” Everyone knew it meant layoffs.

// The floor was extra quiet. Even the people who never wore headphones had them in — not to listen to music, just to block out the silence.

// Vikram walked in with coffee and a printed agenda. “Let’s stay focused,” he said, placing it on the whiteboard. When someone asked if their team was safe, he replied, “Let’s not guess.”

// Kabir sat nearby, refreshing Slack like it was urgent news. His screen had LinkedIn, Naukri, and the HR policy open. When asked if he was okay, he nodded — but didn’t make eye contact. He ate lunch alone, scrolling through his phone.

// Sana was writing a long message to her senior manager. She wasn’t asking about her own job — she was questioning how the decisions were being made. She re-read it twice, then deleted the second half.`,
//   },
//   {
//     id: 3,
//     title: "The Cross-Team Conflict",
//     description: `The design and product teams were fighting again. The director called it “collaborative misalignment,” but it was clearly a mess.

// Slack was full of arguments. Three different threads. Two meetings got pushed. One comment on a shared doc mysteriously disappeared.

// Priya was part of both chats. In the design thread, she replied, “Totally get it 💯” to a rant about deadlines. In the product chat, she said, “Makes sense — will align with the team.” She didn’t share her real opinion. After posting, she muted both channels.

// Anuj hadn’t said much in public. But he quietly sent a screenshot of the argument to a director with the message, “Might want to get ahead of this.” Later, he dropped by the design team with brownies and said, “Can we reset vibes before this explodes?”

// Naveen, the actual project lead, didn’t talk. He created a Jira ticket called “Team Sync: Clarify Alignment.” He added checklists, tagged everyone, marked it high priority, and went back to prepping slides for next week’s leadership meeting.`,
//   },
//   {
//     id: 4,
//     title: "The Appraisal Puzzle",
//     description: `It was appraisal season. The meeting room had no signal and just one window. Tension hung in the air.

// Rajat walked in with a binder full of printed metrics and colorful tabs. When his manager suggested changing a few goals, Rajat quickly agreed. “Absolutely. Whatever you think is best,” he said, already making edits.

// Meera came in with an unmarked appraisal sheet. When asked about her goals or the team, she gave short answers like “They’re fine” and “It’s okay.” She paused a lot, as if trying to remember who she was six months ago. Before leaving, she asked, “Do I need to sign anything?” and softly added, “Thanks for the time.”

// Fatima had her own notes — numbers, quotes from coworkers. When the manager said, “You’re not always aligned,” she paused and asked, “With the company or with you?” Then she thanked him and walked out.`,
//   },
//   {
//     id: 5,
//     title: "The New Joiner Dilemma",
//     description: `Arjun had only joined two months ago. The welcome cake hadn’t even gone stale.

// On Friday, his manager messaged: “Need a quick pitch deck by end of day.” Arjun said yes without thinking. He rushed to gather info from three teams, worked late, and added Dev and Chhavi’s names to the title slide — just to be nice.

// Chhavi noticed it first. “We didn’t really help though,” she whispered. But Dev shrugged and said, “Just smile and wave — he’s trying too hard.” Chhavi didn’t argue.

// By 9 p.m., Arjun was still at his desk, adjusting fonts, fixing images, and checking slide transitions. He sent the final version at 10:42 p.m.

// No one replied.`,
//   },
//   {
//     id: 6,
//     title: "The Ethics Debate",
//     description: `The client wanted the numbers in the report changed — not a lot, just enough to make things look better.

// Everyone got what that really meant. No one said it out loud.

// Rhea stared at the Excel sheet for a while. Then she said, “This isn’t what we agreed on.” Silence. “Should I do it, or will someone else?” Still no answer. She hit ‘Save’ and left for coffee.

// Sahil didn’t speak either. He quietly left a comment on the document: “Need clarity on this input source,” then muted the thread. Later that night, he removed his name from the author list.

// Nitin calmly fixed his shirt and said, “Let’s be practical.” He reused an older version of the report, changed a few numbers, and added a footnote: “Based on revised inputs.” Then he messaged the group, asking if someone else could handle the slides.`,
//   },
//   {
//     id: 7,
//     title: "The Project Switch",
//     description: `A week before the client call, everything changed. A quick Slack message said, “Varun will now present this one. Please align with him.”

// Varun replied with a thumbs-up. By 6 p.m., he had renamed the deck, removed three slides, added his own intro, and sent it to the director saying, “Just streamlined it a bit. Let me know if this works.”

// Lata didn’t complain. She updated the handover doc with links, screenshots, and even added a few jokes. Then she quietly deleted the line that said “original framework by Lata (April).” At 9:14 p.m., she sent a message: “Let me know if you need anything else :)” She rewrote that smiley three times before hitting send.

// Om had built half the backend. He left one comment: "Check logic on slide 14." Didn't join the prep call. Logged off at Om, who had built most of the backend, added one comment: “Check logic on slide 14.” He skipped the prep call and logged off by 7:23 p.m. The next morning, he filled out a transfer form.`,
//   },
//   {
//     id: 8,
//     title: "The Territory Line",
//     description: `Niyati had led the project from day one — the brainstorm, the folder name, even the first draft. At lunch, she said, “This project feels like my baby.” No one disagreed.

// Then the client changed the scope.

// The manager messaged: “Let’s bring in Zubin for a fresh perspective.”

// Zubin was polite. He left a few comments and added one slide titled “Possible alternate flow.” Niyati replied quickly, “Let’s stay focused. We already agreed on the structure.”

// Sana had been working quietly in the background — answering client emails, cleaning up slides, saving backups.

// When the argument started, Sana didn’t take sides. She messaged both: “Want me to merge the versions? Totally okay either way.” No one responded.

// At 10:36 p.m., she merged the slides anyway, matched the colors, and removed names from the title. At 12:07 a.m., she uploaded it as “Final_v5_Sync.” The next morning, the manager reacted with a 👍 emoji.`,
//   },
// ];
